// extracted by mini-css-extract-plugin
module.exports = {"toast-message__width":"success-error-toast_toast-message__width__C0tQ3"};